import { Skeleton, Stack } from '@mui/material'
import { CSSProperties, FC } from 'react'

type ThreadBoxSkeletonProps = { width?: CSSProperties['width'] }

export const ThreadBoxSkeleton: FC<ThreadBoxSkeletonProps> = ({
  width = '100%',
}) => (
  <Stack direction="row" spacing={7} sx={{ width }}>
    <Skeleton variant="rectangular" width={85} height={68} />
    <Stack spacing={3} flex={1}>
      <Skeleton variant="rectangular" width="100%" height={15} />
      <Skeleton variant="rectangular" width="100%" height={15} />
      <Stack direction="row" justifyContent="space-between">
        <Skeleton variant="rectangular" width="40%" height={15} />
        <Skeleton variant="rectangular" width="20%" height={15} />
      </Stack>
    </Stack>
  </Stack>
)
